import { render, staticRenderFns } from "./JSelectZy.vue?vue&type=template&id=33eeea06&scoped=true"
import script from "./JSelectZy.vue?vue&type=script&lang=js"
export * from "./JSelectZy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eeea06",
  null
  
)

export default component.exports